import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Badge
} from "react-bootstrap";
import { BsSearch, BsX, BsCheck } from "react-icons/bs";
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import style from "./ProjectModule.module.scss";
import { TODIS_FORM_FIELD_GROUP, TODIS_DROPDOWN } from "../../components/Forms";
import { TODIS_SECONDARY_BTN } from "../../components/Buttons";
import { HttpService } from "../../HttpService/HttpService";
import { DataTable } from 'primereact/datatable';
import { Column } from "primereact/column";
import { TODIS_Visor_EUACQUIS } from "../../components/Modals/ModalVisorEUACQUIS";
import html2canvas from "html2canvas";
import downloadjs from 'downloadjs';
import { VscSymbolColor } from "react-icons/vsc";
import Iframe from 'react-iframe';
import { VscFiles, VscGlobe, VscOutput, VscDashboard, VscChevronRight, VscGithubAction, VscGraph, VscProject } from "react-icons/vsc";
import { UrlServicesEUACQUIS } from "../../.config";
// Fetch y mapeo de proyectos
const loadProjects = async () => {
  const response = await new HttpService('workflow/projectrequests').get();
  console.log("RESPONSE: ", response)
  return response.map(item => ({
    id: item.requestId,
    formId: item.formId,
    projectName: item.projectName ?? '',
    regionalPartner: item.regionalPartner ?? '',
    transportMode: item.formType ?? '',
    tenTNetwork: item.tentCategory ?? '',
    projectStatus: item.projectStatus ?? '',
    projectType: item.projectType ?? '',
    totalLength: item.totalLength ?? '',
    cost: item.cost ?? '',
    totalProjectCost: item.totalProjectCost ?? '',
    estimatedCompletion: item.estimatedCompletitionDate ?? '',
    deviationMonths: item.accumulatedDelay ?? '',
    validated: item.validated ?? false,
  }));
};

const ProjectModule = () => {
  const [showModal, setShowModal] = useState(false);
  const [datos, setDatos] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading]   = useState(true);

  // Filtros de UI
  const [filters, setFilters] = useState({
    regionalPartners: [],
    transportModes: [],
    tenTNetworks: [],
    projectStatuses: [],
    projectTypes: [],
    keyword: ''
  });

  // Ordenación y selección
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  //const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [fullMap, setfullMap] = useState(false);
  const [urlGraphic, seturlGraphic] = useState("");
  console.log("SELECTED ROWS", selectedRows)
  // Carga inicial de proyectos
  useEffect(() => {
    loadProjects()
      .then(data => {
        setProjects(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error cargando proyectos:', err);
        setLoading(false);
      });
  }, []);

  // Opciones únicas para los filtros
  const options = useMemo(() => {
    const uniq = arr => Array.from(new Set(arr))
      .filter(v => v)
      .sort((a, b) => a.localeCompare(b))
      .map(v => ({ value: v, label: v }));
    return {
      regionalPartners: uniq(projects.map(p => p.regionalPartner)),
      transportModes:   uniq(projects.map(p => p.transportMode)),
      tenTNetworks:     uniq(projects.map(p => p.tenTNetwork)),
      projectStatuses:  uniq(projects.map(p => p.projectStatus)),
      projectTypes:     uniq(projects.map(p => p.projectType))
    };
  }, [projects]);

  // Mapeo de items para TODIS_DROPDOWN (id,name)
  const regionalItems  = options.regionalPartners.map(o => ({ id: o.value, name: o.label }));
  const transportItems = options.transportModes.map(o => ({
    id: o.value,
    name: o.label.replace(/-live$/, '')
  }));
  const tenTItems       = options.tenTNetworks.map(o => ({ id: o.value, name: o.label }));
  const statusItems    = options.projectStatuses.map(o => ({ id: o.value, name: o.label }));
  const typeItems      = options.projectTypes.map(o => ({ id: o.value, name: o.label }));

  // Lógica de filtro
  const filtered = useMemo(() => projects.filter(p => {
    const f = filters;
    if (f.regionalPartners.length && !f.regionalPartners.includes(p.regionalPartner)) return false;
    if (f.transportModes.length   && !f.transportModes.includes(p.transportMode))   return false;
    if (f.tenTNetworks.length     && !f.tenTNetworks.includes(p.tenTNetwork))       return false;
    if (f.projectStatuses.length  && !f.projectStatuses.includes(p.projectStatus))   return false;
    if (f.projectTypes.length     && !f.projectTypes.includes(p.projectType))       return false;
    if (f.keyword && !p.projectName.toLowerCase().includes(f.keyword.toLowerCase())) return false;
    return true;
  }), [projects, filters]);

  // Lógica de ordenación
  const sortedProjects = useMemo(() => {
    const arr = [...filtered];
    if (sortConfig.key) {
      arr.sort((a,b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        const cmp = isNaN(aVal) || isNaN(bVal)
          ? String(aVal).localeCompare(String(bVal))
          : Number(aVal) - Number(bVal);
        return sortConfig.direction === 'asc' ? cmp : -cmp;
      });
    }
    return arr;
  }, [filtered, sortConfig]);
  const imprimirDashboard = async () => {
    //var iframes = document.querySelector("iframe"); //te da los Iframes de la pagina
    var iframes = document.getElementById("euacquis");
    var iframeDocument = iframes.contentWindow.document;
    var contenido = iframeDocument.body;
    //contenido.querySelectorAll(".header-panel").forEach(e => e.remove());

    const canvas = await html2canvas(contenido);
    const dataURL = canvas.toDataURL('image/png');
    downloadjs(dataURL, 'download.png', 'image/png');
  };
  // Exportar a Excel
  const exportExcel = () => {
    if (!selectedRows.length) {
      return Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No rows selected'
      });
    }

    try {
      // 1) Creamos un Set de IDs seleccionados para lookup rápido
      const selectedIdSet = new Set(selectedRows.map(r => r.id));

      // 2) Filtramos sortedProjects para quedarnos sólo con los seleccionados,
      //    y en el orden exacto de sortedProjects
      const dataToExport = sortedProjects.filter(p => selectedIdSet.has(p.id));

      // 3) Definimos explícitamente el orden de las claves (columnas)
      const fieldOrder = [
        'id',
        'projectName',
        'regionalPartner',
        'transportMode',
        'tenTNetwork',
        'projectStatus',
        'projectType',
        'totalLength',
        'cost',
        'totalProjectCost',
        'estimatedCompletion',
        'deviationMonths'
      ];

      // 4) Creamos la hoja indicando ese header
      const ws = XLSX.utils.json_to_sheet(dataToExport, { header: fieldOrder });

      // 5) (Opcional) Si quieres cabeceras legibles, las insertas manualmente:
      const headerLabels = [
        'Id',
        'Project Name',
        'Regional Partner',
        'Transport Mode',
        'TEN-T Network',
        'Status',
        'Type',
        'Total Length',
        'Cost',
        'Total Project Cost',
        'Estimated Completion',
        'Deviation (months)'
      ];
      XLSX.utils.sheet_add_aoa(ws, [headerLabels], { origin: 'A1' });

      // 6) Montamos el libro y lanzamos descarga
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Projects');
      XLSX.writeFile(wb, 'Projects.xlsx');

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Download completed successfully'
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Download failed'
      });
    }
  };
  const arrayToUniqueString = (arr) => {
    const unique = [...new Set(arr)];
    return unique.join(',');
  };

  const sectorMap = {
    "Airports-live": 90,
    "Freight-live": 89,
    "Iww-live": 91,
    "IwwPorts-live": 144,
    "Railways-live": 88,
    "Roads-live": 87,
    "Seaports-live": 143
  };

  const openMap = async () => {
    if (!selectedRows.length) {
      return Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No rows selected'
      });
    }

    // Construir el array de payloads
    const payload = selectedRows.map(row => {
      console.log('TransportMode value:', row.transportMode);
      console.log('Available sectorMap keys:', Object.keys(sectorMap));
      console.log('Sector lookup result:', sectorMap[row.transportMode]);
      
      return {
        module: 85,
        regionalPartner: null,
        tentCategory: null,
        sector: sectorMap[row.transportMode] ?? null,
        year: null,
        layers: null,
        relatedTables: null,
        attributes: null,
        formId: row.formId
      };
    });

    // Mostrar el payload por consola
    console.log('Payload to send to /api/export/map-info:', payload);

    try {
      const resp = await new HttpService('export/map-info').post(payload);

      console.log('Map info response:', resp);

      if (!resp) {
        console.error('export/map-info returned empty response', resp);
        return Swal.fire({ icon: 'error', title: 'Error', text: 'Empty response from map-info service' });
      }

      // Aceptar varias formas de respuesta:
      // 1) { data: { data: [...] } }
      // 2) { data: [...] }
      // 3) [...] (array)
      const maybeData = resp.data ?? resp;
      const dashboardData = maybeData.data ?? maybeData;

      if (!dashboardData) {
        console.error('Unexpected export/map-info response shape', resp);
        const preview = JSON.stringify(resp).slice(0, 1000);
        return Swal.fire({ icon: 'error', title: 'Error', html: `Unexpected response from map-info service:<pre style="text-align:left;white-space:pre-wrap;">${preview}</pre>` });
      }

      setDatos(dashboardData);
      setShowModal(true);
    } catch (err) {
      console.error('Error calling export/map-info', err);
      // If the error contains a response, show some details to help debugging
      const detail = err?.response ? JSON.stringify(err.response).slice(0, 1000) : null;
      return Swal.fire({
        icon: 'error',
        title: 'Error',
        html: `Failed to fetch map info.${detail ? '<pre style="text-align:left;white-space:pre-wrap;">' + detail + '</pre>' : ''}`
      });
    }
  };

  // Acciones auxiliares
  const openCharts = async () => {
    // if (!selectedRows.length) {
    //   return Swal.fire({
    //     icon: 'error',
    //     title: 'Error',
    //     text: 'No rows selected'
    //   });
    // }

    // Construir el array de payloads (misma estructura que openMap)
    const payload = selectedRows.map(row => ({
      module: 85,
      regionalPartner: [row.regionalPartner],
      tentCategory: null,
      sector: sectorMap[row.transportMode] ?? null,
      year: null,
      layers: null,
      relatedTables: null,
      attributes: null,
      formId: row.formId
    }));
    const payload2 = [
      selectedRows.map(row => row.formId),
      selectedRows.map(row => sectorMap[row.transportMode] ?? null)
    ];
    const sector = arrayToUniqueString(payload2[1]);
    const formid = arrayToUniqueString(payload2[0]);
    var dashboard = "projectmodule";
    seturlGraphic(UrlServicesEUACQUIS[dashboard] + "#sector=" + sector + "#formid=" + formid);
    if (!fullMap) { setfullMap(true) }


    // try {
    //   const data = await new HttpService('projectModule/chartsInfo').post(payload);
    //   console.log('Charts response:', data);
    //   Swal.fire({
    //     icon: 'success',
    //     title: 'Success',
    //     text: 'Charts update request completed successfully'
    //   });
    // } catch (err) {
    //   console.error(err);
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Error',
    //     text: 'Failed to fetch charts'
    //   });
    // }
  };

  const refreshCharts = async () => {
    if (!selectedRows.length) {
      return Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No rows selected'
      });
    }

    // Construir el array de payloads (misma estructura que openMap)
    const payload = selectedRows.map(row => ({
      module: 85,
      regionalPartner: [row.regionalPartner],
      tentCategory: null,
      sector: sectorMap[row.transportMode] ?? null,
      year: null,
      layers: null,
      relatedTables: null,
      attributes: null,
      formId: row.formId
    }));

    try {
      const data = await new HttpService('projectModule/massiveChartsInfoUpload').post(payload);
      console.log('Charts response:', data);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Charts request completed successfully',
        text: data
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch charts'
      });
    }
  };

  return (
    <Container fluid className="col-sm-12">
      <Row style={{ height: "100%" }}>
        <Col style={{ paddingRight: 0 }} sm={fullMap ? 6 : 12}>
          <Container fluid className="todis-form-wrapper p-4" style={{ height: '98%' }} >
            {/* Filtros */}
            <Row className="pb-3 gx-2 align-items-center">
              <Col lg={2} md={4} sm={6} xs={12}>
                <TODIS_DROPDOWN
                  title="Regional Partner"
                  multiple
                  response={!loading}
                  items={regionalItems}
                  handleSelect={key => setFilters(f => ({
                    ...f,
                    regionalPartners: f.regionalPartners.includes(key)
                      ? f.regionalPartners.filter(v => v !== key)
                      : [...f.regionalPartners, key]
                  }))}
                />
              </Col>
              <Col lg={2} md={4} sm={6} xs={12}>
                <TODIS_DROPDOWN
                  title="Transport Mode"
                  multiple
                  response={!loading}
                  items={transportItems}
                  handleSelect={key => setFilters(f => ({
                    ...f,
                    transportModes: f.transportModes.includes(key)
                      ? f.transportModes.filter(v => v !== key)
                      : [...f.transportModes, key]
                  }))}
                />
              </Col>
              <Col lg={2} md={4} sm={6} xs={12}>
                <TODIS_DROPDOWN
                  title="TEN-T Network"
                  multiple
                  response={!loading}
                  items={tenTItems}
                  handleSelect={key => setFilters(f => ({
                    ...f,
                    tenTNetworks: f.tenTNetworks.includes(key)
                      ? f.tenTNetworks.filter(v => v !== key)
                      : [...f.tenTNetworks, key]
                  }))}
                />
              </Col>
              <Col lg={2} md={4} sm={6} xs={12}>
                <TODIS_DROPDOWN
                  title="Project Status"
                  multiple
                  response={!loading}
                  items={statusItems}
                  handleSelect={key => setFilters(f => ({
                    ...f,
                    projectStatuses: f.projectStatuses.includes(key)
                      ? f.projectStatuses.filter(v => v !== key)
                      : [...f.projectStatuses, key]
                  }))}
                />
              </Col>
              {/* <Col lg={2} md={4} sm={6} xs={12}>
                  <TODIS_DROPDOWN
                    title="Project Type"
                    multiple
                    response={!loading}
                    items={typeItems}
                    handleSelect={key => setFilters(f => ({
                      ...f,
                      projectTypes: f.projectTypes.includes(key)
                        ? f.projectTypes.filter(v => v !== key)
                        : [...f.projectTypes, key]
                    }))}
                  />
                </Col> */}
              <Col lg={2} md={4} sm={6} xs={12}>
                <TODIS_FORM_FIELD_GROUP
                  type="notify"
                  placeholder="Keyword"
                  icon={BsSearch}
                  value={filters.keyword}
                  onChange={e => setFilters(f => ({ ...f, keyword: e.target.value }))}
                />
              </Col>
            </Row>

            {/* Botones de acción */}
            <Row className="pb-3 text-end">
              <Col>
                <TODIS_SECONDARY_BTN title="Export Excel" iconName="downloadExcel" onclick={exportExcel} className="me-2" />
                <TODIS_SECONDARY_BTN title="Charts" iconName="chart" onclick={openCharts} className="me-2" />
                <TODIS_SECONDARY_BTN title="Map" iconName="map" onclick={openMap} />
                <TODIS_SECONDARY_BTN title="Refresh charts" iconName="chart" onclick={refreshCharts} className="me-2" />
              </Col>
            </Row>

            {/* Filtros activos */}
            <Row className="ps-4 pt-3 col-lg-12" style={{ maxHeight: '50px', overflowY: 'auto' }}>
              <Row className="float-start gx-2">
                {/* Regional Partner */}
                <Col lg={2} className="ps-0" style={{ width: 'auto' }}>
                  <h6>Regional Partner:&nbsp;
                    {filters.regionalPartners.length > 0 ? (
                      filters.regionalPartners.map((id) => {
                        const label = options.regionalPartners.find(o => o.value === id)?.label || id;
                        return (
                          <Badge key={id} className={style.bgFilter} bg="primary">
                            <span className={style.cursorPointer} onClick={() => setFilters(f => ({ ...f, regionalPartners: f.regionalPartners.filter(v => v !== id) }))}>
                              <BsX fontSize={16} color="#3e84b8" />
                            </span>&nbsp;{label}
                          </Badge>
                        );
                      })
                    ) : (
                      <Badge className={style.bgFilter} bg="primary">
                        <BsCheck fontSize={16} color="#3e84b8" /> All Regional Partner
                      </Badge>
                    )}
                  </h6>
                </Col>
                {/* Transport Mode */}
                <Col lg={2} className="ps-0" style={{ width: 'auto' }}>
                  <h6>Transport Mode:&nbsp;
                    {filters.transportModes.length > 0 ? (
                      filters.transportModes.map((id) => {
                        const label = options.transportModes.find(o => o.value === id)?.label || id;
                        return (
                          <Badge key={id} className={style.bgFilter} bg="primary">
                            <span className={style.cursorPointer} onClick={() => setFilters(f => ({ ...f, transportModes: f.transportModes.filter(v => v !== id) }))}>
                              <BsX fontSize={16} color="#3e84b8" />
                            </span>&nbsp;{label}
                          </Badge>
                        );
                      })
                    ) : (
                      <Badge className={style.bgFilter} bg="primary">
                        <BsCheck fontSize={16} color="#3e84b8" /> All Transport Mode
                      </Badge>
                    )}
                  </h6>
                </Col>
                {/* TEN-T Network */}
                <Col lg={2} className="ps-0" style={{ width: 'auto' }}>
                  <h6>TEN-T Network:&nbsp;
                    {filters.tenTNetworks.length > 0 ? (
                      filters.tenTNetworks.map((id) => {
                        const label = options.tenTNetworks.find(o => o.value === id)?.label || id;
                        return (
                          <Badge key={id} className={style.bgFilter} bg="primary">
                            <span className={style.cursorPointer} onClick={() => setFilters(f => ({ ...f, tenTNetworks: f.tenTNetworks.filter(v => v !== id) }))}>
                              <BsX fontSize={16} color="#3e84b8" />
                            </span>&nbsp;{label}
                          </Badge>
                        );
                      })
                    ) : (
                      <Badge className={style.bgFilter} bg="primary">
                        <BsCheck fontSize={16} color="#3e84b8" /> All TEN-T Network
                      </Badge>
                    )}
                  </h6>
                </Col>
                {/* Project Status */}
                <Col lg={2} className="ps-0" style={{ width: 'auto' }}>
                  <h6>Status:&nbsp;
                    {filters.projectStatuses.length > 0 ? (
                      filters.projectStatuses.map((id) => {
                        const label = options.projectStatuses.find(o => o.value === id)?.label || id;
                        return (
                          <Badge key={id} className={style.bgFilter} bg="primary">
                            <span className={style.cursorPointer} onClick={() => setFilters(f => ({ ...f, projectStatuses: f.projectStatuses.filter(v => v !== id) }))}>
                              <BsX fontSize={16} color="#3e84b8" />
                            </span>&nbsp;{label}
                          </Badge>
                        );
                      })
                    ) : (
                      <Badge className={style.bgFilter} bg="primary">
                        <BsCheck fontSize={16} color="#3e84b8" /> All Status
                      </Badge>
                    )}
                  </h6>
                </Col>
                {/* Project Type */}
                {/* <Col lg={2} className="ps-0" style={{ width: 'auto' }}>
                    <h6>Type:&nbsp;
                      {filters.projectTypes.length > 0 ? (
                        filters.projectTypes.map((id) => {
                          const label = options.projectTypes.find(o => o.value === id)?.label || id;
                          return (
                            <Badge key={id} className={style.bgFilter} bg="primary">
                              <span className={style.cursorPointer} onClick={() => setFilters(f => ({ ...f, projectTypes: f.projectTypes.filter(v => v !== id) }))}>
                                <BsX fontSize={16} color="#3e84b8" />
                              </span>&nbsp;{label}
                            </Badge>
                          );
                        })
                      ) : (
                        <Badge className={style.bgFilter} bg="primary">
                          <BsCheck fontSize={16} color="#3e84b8" /> All Type
                        </Badge>
                      )}
                    </h6>
                  </Col> */}
              </Row>
            </Row>

            <Row
              className="todis-form-action-panel pb-3"
              style={{ overflow: "auto", maxHeight: "calc(87vh - 275px)" }}
            >
              <Col>
                <DataTable
                  value={sortedProjects}
                  loading={loading}
                  dataKey="id"
                  selection={selectedRows}
                  onSelectionChange={e => setSelectedRows(e.value)}
                  sortField={sortConfig.key}
                  sortOrder={sortConfig.direction === 'asc' ? 1 : -1}
                  onSort={e => {
                    setSortConfig({
                      key: e.sortField,
                      direction: e.sortOrder === 1 ? 'asc' : 'desc'
                    });
                  }}
                  responsiveLayout="scroll"
                >
                  {/* Columna de checkboxes */}
                  <Column selectionMode="multiple" style={{ width: '3em' }} />

                  {/* Columnas de datos */}
                  <Column field="projectName" header="Project Name" sortable style={{ minWidth: '12rem' }} />
                  <Column field="regionalPartner" header="Regional Partner" sortable style={{ minWidth: '10rem' }} />
                  <Column field="transportMode" header="Transport Mode" sortable style={{ minWidth: '10rem' }} />
                  <Column field="tenTNetwork" header="TEN-T Network" sortable style={{ minWidth: '10rem' }} />
                  <Column field="projectStatus" header="Status" sortable style={{ minWidth: '8rem' }} />
                  <Column field="projectType" header="Type" sortable style={{ minWidth: '8rem' }} />
                  <Column field="totalLength" header="Total Length" sortable style={{ minWidth: '8rem' }} />
                  <Column field="cost" header="Cost" sortable style={{ minWidth: '8rem' }} />
                  <Column field="totalProjectCost" header="Total Ptoject Cost" sortable style={{ minWidth: '8rem' }} />
                  <Column field="estimatedCompletion" header="Estimated Completion" sortable style={{ minWidth: '12rem' }} />
                  <Column field="deviationMonths" header="Deviation (months)" sortable style={{ minWidth: '8rem' }} />
                </DataTable>
              </Col>
            </Row>
            {showModal && <TODIS_Visor_EUACQUIS title={"Map"} dataDashboard={datos} show={showModal} visor={"PROJECTMODULE"} onHide={() => setShowModal(false)} />}
          </Container>
        </Col>
        {fullMap &&
          <>

            <Col style={{ padding: 0, width: '1.333333%', flex: '0 0 auto' }}><div style={{ paddingTop: "40vh", paddingLeft: "4px" }}><div style={{ display: "flex", alignItems: "center", borderRadius: "15px 0px 0px 15px", backgroundColor: "#004494", height: "100px" }} onClick={() => setfullMap(false)}><VscChevronRight size="23" color="white" /></div><div style={{ display: "flex", alignItems: "center", borderRadius: "15px 0px 0px 15px", backgroundColor: "#004494", height: "100px" }} onClick={imprimirDashboard}><VscSymbolColor size="23" color="white" /></div></div></Col>

            <Col style={{ paddingLeft: 0, width: '48.333333%', flex: '0 0 auto', height: "98%" }} >

              <Iframe url={urlGraphic}
                width="100%"
                height="100%"
                id="euacquis"
                name="euacquis"
                display="block"
                position="relative" />

            </Col>
          </>

        }
      </Row>
    </Container>
  );
};

export default ProjectModule;
